import { isObject } from 'lodash';

/**
 * Extracts a human-readable error message from various error shapes:
 * - JS Error objects (e.message)
 * - API logical errors thrown by retry (e.data.data.error_text / error_message)
 * - Unknown API response objects (JSON.stringify of e.data.data)
 * - Fallback: 'API error'
 * @param {Error|object} e - caught error or rejected response object
 * @returns {string}
 */
export const getErrorMessage = (e) => {
    const data = e?.data?.data;
    const error = e?.message || data?.error_text || data?.error_message;

    if (error) {
        return error;
    }

    if (isObject(data)) {
        return JSON.stringify(data);
    }

    return 'API error';
};
